import { shadowRoot } from "./_dom-context.js";

export const initNavButton = () => {
	const navButton = shadowRoot.querySelector(".fn-nav-toggle");

	if (navButton) {
		navButton.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				event.currentTarget.getAttribute("aria-expanded") === "true"
					? "false"
					: "true",
			);
		});
	}

	const mobileToggles = shadowRoot.querySelectorAll(".fn-mobile-toggle");

	for (const mobileToggle of mobileToggles) {
		mobileToggle.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				event.currentTarget.getAttribute("aria-expanded") === "true"
					? "false"
					: "true",
			);
		});
	}
};
